var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home l-container"},[_c('router-link',{staticClass:"u-link u-block u-mt32",attrs:{"to":{name: 'lp'}}},[_vm._v("＜ 戻る")]),_c('div',{staticClass:"uCalc_353709"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }